import { i18n } from 'localization'
import { parseDate, parsePerson } from './utils'

export default class ClinicalEvaluation {
	static fromJSON(json) {
		return new ClinicalEvaluation(json.id)
			.withCausalLink(json.causalLink)
			.withBody(json.body)
			.withDate(json.createdAt)
			.withDoctor(json.doctor)
			.withEntity(json.doctor)
	}

	constructor(id) {
		this.id = id
		this.textId = `comment_${id || ''}`
		this.key = this.textId
	}

	withCausalLink(causalLink) {
		this.causalLink = causalLink
		return this
	}
	withBody(body) {
		this.body = body?.replace(/<br\/>/gi, '\r\n').trim()
		this.text = body || i18n`Empty`
		return this
	}
	withDate(dateStr) {
		if (dateStr) {
			this.date = parseDate(dateStr)
		} else {
			this.date = {}
		}
		return this
	}

	withDoctor(json) {
		this.doctor = json ? parsePerson(json) : null
		return this
	}

	withEntity(json) {
		this.entity = json?.entity?.name || ''
		return this
	}
}
